import React from 'react';
export var AnalyticsReactContext = React.createContext({
    getAtlaskitAnalyticsContext: null,
    getAtlaskitAnalyticsEventHandlers: null,
});
//# sourceMappingURL=AnalyticsReactContext.js.map